import React, { Component } from "react";
import { connect } from "react-redux";
import { Col, Button, Row } from "react-bootstrap";

import Title from "./sub_components/title_a";
import ImportData_a from "./sub_components/importData_a";
import ImportDataMob from "./mobileComponents/ImportDataMob";
import Learning from "./sub_components/learning";
import Inference from "./sub_components/MainInference";
import image_model from "../tfjs_model_dev/script";

import bttnEye from "../assets/mobileAssets/eyeon.svg";

import ExpModelBttn from "./asset_components/ExpModelBttn";
import AddClassBttn from "./asset_components/AddClassBttn";
import AddClassBttnMob from "./asset_components/mobileAssets/AddClassBttnMob";

let trainingSession = null;

class main_a extends Component {
  classArray = [];
  samplesJSON = new Object();
  classNArr = [];
  widthView = 0;
  classRecdToTrain = 0;
  displayComponent = null;
  selected = "SAMPLES";
  mobileComponent = null;
  mobileNavSelected1 = null;
  mobileNavSelected2 = null;
  mobileNavSelected3 = null;
  isChrome =
    !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

  constructor(props) {
    super(props);
    this.state = {
      classNo: 1,
      type: "DESKTOP",
      selected: "SAMPLES",
      width: 0,
      typeLocal: null,
    };
  }

  //Handles to add multiple ImportData Component
  handleAddClass = (e) => {
    if (this.props.type === "DESKTOP") {
      this.setState({
        classNo: ++this.state.classNo,
      });
      this.classArray.push(
        <ImportData_a
          preceiveTensors={this.receiveTensorsAndClassN.bind(this)}
          preceiveSignal={this.deleteClass.bind(this)}
          key={this.state.classNo}
          keyId={this.state.classNo}
          classCount={this.state.classNo}
        />
      );
    } else if (this.props.type === "MOBILE") {
      this.setState({
        classNo: ++this.state.classNo,
      });
      this.classArray.push(
        <ImportDataMob
          preceiveTensors={this.receiveTensorsAndClassN.bind(this)}
          preceiveSignal={this.deleteClass.bind(this)}
          key={this.state.classNo}
          keyId={this.state.classNo}
          classCount={this.state.classNo}
        />
      );
    }
  };

  deleteClass = (key) => {
    if (this.classArray.length === 1) {
      alert("Atleast one class must exist");
    } else {
      let index = this.classArray.map((element) => element.key).map(Number);
      index = index.indexOf(key);
      this.classArray.splice(index, 1);
      this.setState({
        //classNo: --this.state.classNo
      });
    }
  };

  //Tensors of all classes are concat to this.tensJSON
  //Tensor is availabe in this.tensArr
  //LEARNING
  async receiveTensorsAndClassN(data, className) {
    this.props.globalTrainingStatus(false);
    if (this.classArray.length > 1) {
      this.classRecdToTrain += 1
      if(data.length > 0) {
        if (this.classNArr.indexOf(className) < 0) {
          this.classNArr.push(className);
          this.props.sendClassNArray(this.classNArr);
        }
        this.samplesJSON[className] = data;
      }
      if (this.classRecdToTrain === this.classArray.length) {
        if (trainingSession) {
          trainingSession.dispose_all();
          trainingSession = null;
        }
        trainingSession = new image_model();
        await trainingSession
        .train_model(this.samplesJSON, this.classNArr, this.props.epochs,
          this.props.batchSize,
          this.props.learningRate)
          .then((results) => {
            this.setState({
              trainingStatus: true,
              selected: "PREVIEW",
            });
            this.props.notStopTraining(false);
            this.props.trainingStartStop(false)
            this.props.stopGlobalCam(false, '1.0')
          });
        this.props.globalTrainingStatus(true);
        document.getElementById('startLearning').innerHTML = 'Model Trained'
        this.samplesJSON = new Object();
        this.classNArr = [];
        this.classRecdToTrain = 0
      }
    } else {
      alert("Atleast 2 class must exist to train");
    }
  }

  dispMobileComponent = (e) => {
    this.setState({
      selected: e.target.name,
    });
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
  };

  componentWillMount() {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      this.classArray.push(
        <ImportDataMob
          preceiveTensors={this.receiveTensorsAndClassN.bind(this)}
          preceiveSignal={this.deleteClass.bind(this)}
          keyId={1}
          key={1}
          classCount={1}
        />
      );
    } else {
      this.classArray.push(
        <ImportData_a
          preceiveTensors={this.receiveTensorsAndClassN.bind(this)}
          preceiveSignal={this.deleteClass.bind(this)}
          keyId={1}
          key={1}
          classCount={1}
        />
      );
    }

  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.width < 420 && nextProps.type === "MOBILE") {
      this.widthView = 420;
    } else this.widthView = nextProps.width;
    if (nextProps.width < 1345 && nextProps.type === "DESKTOP") {
      this.widthView = 1345;
    } else this.widthView = nextProps.width;
  }

  render() {
    let visibleSample = "hidden",
      visibleLearning = "hidden",
      visiblePreview = "hidden",
      bttnStatus = true;
    if (this.classArray.length > 1) {
      bttnStatus = false;
    }
    if (this.props.type === "MOBILE") {
      if (this.state.selected === "SAMPLES") {
        this.mobileNavSelected1 = { bgColor: "#F7D722", textColor: "#232D43" };
        this.mobileNavSelected2 = this.mobileNavSelected3 = {
          bgColor: "#2E3A53",
          textColor: "#C2C0BD",
        };
        visibleSample = "visible";
      } else if (this.state.selected === "LEARNING") {
        this.mobileNavSelected2 = { bgColor: "#F7D722", textColor: "#232D43" };
        this.mobileNavSelected1 = this.mobileNavSelected3 = {
          bgColor: "#2E3A53",
          textColor: "#C2C0BD",
        };
        visibleLearning = "visible";
      } else if (this.state.selected === "PREVIEW") {
        this.mobileNavSelected3 = { bgColor: "#F7D722", textColor: "#232D43" };
        this.mobileNavSelected2 = this.mobileNavSelected1 = {
          bgColor: "#2E3A53",
          textColor: "#C2C0BD",
        };
        visiblePreview = "visible";
      }
      this.mobileComponent = (
        <div>
          <div
            style={{
              visibility: visibleSample,
              position: "absolute",
              marginLeft: "auto",
              marginRight: "auto",
              left: "0px",
              right: "0px",
            }}
          >
            <div
              style={{
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                margin: "auto",
                marginTop: "5px",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {this.classArray.map((classArray) => classArray)}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "auto",
                marginTop: "30px",
                marginBottom: "30px",
              }}
            >
              <Button
                style={{
                  padding: "0px",
                  borderWidth: "0px",
                  outline: "none",
                  borderRadius: "5px",
                }}
                onClick={this.handleAddClass.bind(this)}
              >
                <AddClassBttnMob />
              </Button>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "auto",
                marginTop: "30px",
                marginBottom: "30px",
              }}
            >
              <Button
                name="LEARNING"
                style={{
                  padding: "0px",
                  border: "0px",
                  backgroundColor: "#17D9AA",
                  boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.25)",
                  borderRadius: "3px",
                  outline: "none",
                  width: "248px",
                  height: "52px",
                  color: "#232D43",
                  fontSize: "14px",
                  fontFamily: "Helvetica",
                  fontStyle: "normal",
                  fontWeight: "300",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={this.dispMobileComponent}
              >
                Start Learning
              </Button>
            </div>
          </div>
          <div
            style={{
              visibility: visibleLearning,
              position: "absolute",
              marginLeft: "auto",
              marginRight: "auto",
              left: "0px",
              right: "0px",
            }}
          >
            <Row
              style={{
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                margin: "auto",
              }}
            >
              <Learning bttnStatus={bttnStatus} />
            </Row>
            <Row
              style={{
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                margin: "auto",
                marginTop: "30px",
                marginBottom: "30px",
              }}
            >
              <Button
                name="PREVIEW"
                style={{
                  padding: "0px",
                  border: "0px",
                  backgroundColor: "#17D9AA",
                  boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.25)",
                  borderRadius: "3px",
                  outline: "none",
                  width: "248px",
                  height: "52px",
                  color: "#232D43",
                  fontSize: "14px",
                  fontFamily: "Helvetica",
                  fontStyle: "normal",
                  fontWeight: "300",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={this.dispMobileComponent}
              >
                <img src={bttnEye} alt="add" style={{ paddingRight: "5px" }} />
                Check Preview
                {/* <CheckPreviewBttn /> */}
              </Button>
            </Row>
          </div>
          <div
            style={{
              visibility: visiblePreview,
              position: "absolute",
              marginLeft: "auto",
              marginRight: "auto",
              left: "0px",
              right: "0px",
            }}
          >
            <Row
              style={{
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                margin: "auto",
              }}
            >
              <Inference deviceType={this.props.type} obj={trainingSession} />
            </Row>
            <Row
              style={{
                textAlign: "left",
                display: "flex",
                justifyContent: "center",
                margin: "auto",
                marginTop: "30px",
              }}
            >
              <Button
                style={{
                  margin: "0px",
                  padding: "0px",
                  borderWidth: "0px",
                  outline: "none",
                  borderRadius: "3px",
                }}
              >
                <ExpModelBttn />
              </Button>
            </Row>
          </div>
        </div>
      );
      this.displayComponent = (
        <div>
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "313px",
                margin: "auto",
                marginTop: "30px",
                borderRadius: "4px",
                backgroundColor: "#2E3A53",
              }}
            >
              <Col xs={4} md={4} style={{ paddingLeft: "0px" }}>
                <Button
                  onClick={this.dispMobileComponent}
                  name="SAMPLES"
                  style={{
                    width: 313 / 3,
                    textAlign: "center",
                    background: "#2E3A53",
                    color: "#C2C0BD",
                    justifyContent: "center",
                    display: "flex",
                    padding: "0px",
                    border: "0px",
                    height: "31px",
                    borderRadius: "4px",
                    outline: "none",
                    backgroundColor: this.mobileNavSelected1["bgColor"],
                    color: this.mobileNavSelected1["textColor"],
                  }}
                >
                  Samples
                </Button>
              </Col>
              <Col xs={4} md={4} style={{ paddingLeft: "0px" }}>
                <Button
                  onClick={this.dispMobileComponent}
                  name="LEARNING"
                  style={{
                    width: 313 / 3,
                    height: "31px",
                    textAlign: "center",
                    background: "#2E3A53",
                    color: "#C2C0BD",
                    justifyContent: "center",
                    display: "flex",
                    padding: "0px",
                    border: "0px",
                    borderRadius: "4px",
                    outline: "none",
                    backgroundColor: this.mobileNavSelected2["bgColor"],
                    color: this.mobileNavSelected2["textColor"],
                  }}
                >
                  Learning
                </Button>
              </Col>
              <Col xs={4} md={4} style={{ paddingLeft: "0px" }}>
                <Button
                  onClick={this.dispMobileComponent}
                  name="PREVIEW"
                  style={{
                    width: 313 / 3,
                    height: "31px",
                    textAlign: "center",
                    background: "#2E3A53",
                    color: "#C2C0BD",
                    justifyContent: "center",
                    display: "flex",
                    padding: "0px",
                    border: "0px",
                    borderRadius: " 4px",
                    outline: "none",
                    backgroundColor: this.mobileNavSelected3["bgColor"],
                    color: this.mobileNavSelected3["textColor"],
                  }}
                >
                  Preview
                </Button>
              </Col>
            </div>
          </div>
          <div>{this.mobileComponent}</div>
        </div>
      );
    } else if (this.props.type === "DESKTOP") {
      this.displayComponent = (
        <div style={{ width: this.widthView }}>
          <Col xs={4} md={4} lg={4}>
            <div
              style={{
                marginLeft: "59px",
                marginTop: "52px",
              }}
            >
              {this.classArray.map((classArray) => classArray)}
            </div>
            <div
              style={{
                marginLeft: "59px",
                marginTop: "52px",
              }}
            >
              <Button
                name="LEARNING"
                style={{
                  padding: "0px",
                  border: "0px",
                  outline: "none",
                  borderRadius: "5px",
                }}
                onClick={this.handleAddClass.bind(this)}
              >
                <AddClassBttn />
              </Button>
            </div>
          </Col>
          <Col xs={4} md={4} lg={4}>
            <div style={{ marginLeft: "58px" }}>
              <Learning deviceType={this.props.type} bttnStatus={bttnStatus} />
            </div>
          </Col>
          <Col xs={4} md={4} lg={4}>
            <div>
              <Inference deviceType={this.props.type} obj={trainingSession} />
            </div>
          </Col>
        </div>
      );
    } else if (this.props.type === 'NOSUPPORT') {
      this.displayComponent = <div style={{color: '#FFFF', margin: '0 auto'}}>
        <center>
          NOT SUPPORTED ON THIS DEVICE
        </center>
      </div>
    }
      
    return (
      <div>
        <Title width={this.widthView} />
        {this.displayComponent}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    epochs: state.epochs,
    batchSize: state.batchSize,
    learningRate: state.learningRate,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    sendClassNArray: (cArr) => {
      dispatch({
        type: "CLASS_ARR",
        cArr: cArr,
      });
    },
    //TRUE WHEN TRAINING START AND FALSE WHEN STOPPED
    trainingStartStop: (status) => {
      dispatch({
        type: 'TRAINING_START_STOP',
        startStopSignal: status
      })
    },
    //DISABLE CAM ON MOUNT
    stopGlobalCam: (gCam, classID) => {
      dispatch({
        type: "GLOBAL_CAM",
        gCam: gCam,
        classID: classID,
      });
    },
    //changing store to stop training
    notStopTraining: (sSignal) => {
      dispatch({
        type: "STOP_TRAINING",
        sSignal: sSignal,
      });
    },
    //OPENS PREVIEW
    globalTrainingStatus: (tStatus) => {
      dispatch({
        type: "TRAINING_STATUS",
        tStatus: tStatus,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(main_a);
